<template>
    <div class="product-row">
        <a :href="'#/SearchResult?typeid='+textData.id" class="row-title" :style="'background-image: url('+textData.bg+');'">
            <h3>{{ textData.title }}</h3>
            <img src="@/assets/img/i-arr.png" alt="">
        </a>
        <div class="product-con">
            <div class="big">
                <img :src="textData.bigBg" alt="" class="bg">
                <img :src="textData.bigTit" alt="" class="tit-img">
                <h3>{{ textData.title }}</h3>
                <p>{{ textData.p }}</p>
                <span :style="'background-color:'+textData.color">{{textData.span}}</span>
            </div>
            <div class="right mal15">
                <div class="list display ">
                    <div @click="goGoodsdetail(item)" class="item"
                            v-if="list1"
                         @mouseenter="hoverIndex = index"
                         :class="hoverIndex === index ? 'active' : hoverIndex === '' ? 'noactiveitem' : 'activeitem' " v-for="(item,index) in list1"
                         :key="index">
                        <div class="def">
                            <div class="pic">
                                <el-image style="width: 100%;height: 100%" fit="scale-down" :src="item.pictureUrl"><div slot="error" class="image-slot"><img :src="defaultImg"></div></el-image>
<!--                                <img :src="item.pictureUrl || defaultImg" alt="">-->
                            </div>
                            <h3 class="text_hidden1 paddingLR10px wid100 text_cen">{{ item.name }}</h3>
							<p v-if="item.normalPrice==0">询价</p>
                            <p v-else>¥{{ islogin?(item.customerPrice < item.discountPrice ? item.customerPrice: item.customerPrice > item.discountPrice ? item.discountPrice : item.normalPrice) : item.normalPrice }}</p>
                            <span v-if="islogin && ((item.customerPrice < item.normalPrice) || (item.discountPrice < item.normalPrice))">原价：￥{{item.normalPrice}}</span>
                        </div>
                        <div class="active">
							<div class="text" style="position: initial;" :style="'background-color:'+textData.color2">
								<h3 class="text_hidden1 paddingLR10px wid100 text_cen">{{ item.name }}</h3>
								<p v-if="item.normalPrice==0">询价</p>
								<p v-else>¥{{ islogin?(item.customerPrice < item.discountPrice ? item.customerPrice: item.customerPrice > item.discountPrice ? item.discountPrice : item.normalPrice) : item.normalPrice }}</p>
								<span v-if="islogin && ((item.customerPrice < item.normalPrice) || (item.discountPrice < item.normalPrice))">原价：￥{{item.normalPrice}}</span>
							</div>
                            <div class="pic" style="width: 169px;height: 189px;right: 0;left: initial">
<!--                                <img :src="item.pictureUrl || defaultImg" alt="" style="max-width: 179px;max-height: 189px;object-fit: contain;">-->
                                <el-image style="width: 100%;height: 100%" fit="scale-down" :src="item.pictureUrl"><div slot="error" class="image-slot"><img :src="defaultImg"></div></el-image>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="list display " v-if="list2">
                    <div @click="goGoodsdetail(item)" class="item"
                         @mouseenter="hoverIndex2 = index" :class="hoverIndex2 === index ? 'active' : hoverIndex2 === '' ? 'noactiveitem' : 'activeitem'" v-for="(item,index) in list2" :key="index">
                        <div class="def">
                            <div class="pic">
<!--                                <img :src="item.pictureUrl || defaultImg" alt="">-->
                                <el-image style="width: 100%;height: 100%" fit="scale-down" :src="item.pictureUrl"><div slot="error" class="image-slot"><img :src="defaultImg"></div></el-image>
                            </div>
                            <h3 class="text_hidden1 paddingLR10px wid100 text_cen">{{ item.name }}</h3>
							<p v-if="item.normalPrice==0">询价</p>
							<p v-else>¥{{ islogin?(item.customerPrice < item.discountPrice ? item.customerPrice: item.customerPrice > item.discountPrice ? item.discountPrice : item.normalPrice) : item.normalPrice }}</p>
							<span v-if="islogin && ((item.customerPrice < item.normalPrice) || (item.discountPrice < item.normalPrice))">原价：￥{{item.normalPrice}}</span>
                        </div>
                        <div class="active">
							<div class="text" style="position: initial;" :style="'background-color:'+textData.color2">
								<h3 class="text_hidden1 paddingLR10px wid100 text_cen">{{ item.name }}</h3>
								<p v-if="item.normalPrice==0">询价</p>
								<p v-else>¥{{ islogin?(item.customerPrice < item.discountPrice ? item.customerPrice: item.customerPrice > item.discountPrice ? item.discountPrice : item.normalPrice) : item.normalPrice }}</p>
								<span v-if="islogin && ((item.customerPrice < item.normalPrice) || (item.discountPrice < item.normalPrice))">原价：￥{{item.normalPrice}}</span>
							</div>
							<div class="pic" style="width: 169px;height: 189px;right: 0;left: initial">
<!--								<img :src="item.pictureUrl || defaultImg" alt="" style="max-width: 179px;max-height: 189px;object-fit: contain;">-->
                                <el-image style="width: 100%;height: 100%" fit="scale-down" :src="item.pictureUrl"><div slot="error" class="image-slot"><img :src="defaultImg"></div></el-image>
							</div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "product-row",
    props: {
        textData:[Object],
        bg: [String],
        color:[String]
    },
    data() {
        return {
            hoverIndex: '',
            hoverIndex2: '',
            list1:[],
            list2:[],
			islogin:localStorage.getItem('Token')?true:false, // 是否登录
        }
    },
    watch:{
        textData(n,o) { // 新数据 旧数据
            console.log(n)
            if(n.goodslist){
                this.list1=n.goodslist.slice(0,4)
                this.list2=n.goodslist.slice(4)
                this.list1.forEach(item=>{
                    item.customerPrice=parseFloat(item.customerPrice)
                    item.discountPrice=parseFloat(item.discountPrice)
                    item.normalPrice=parseFloat(item.normalPrice)
                })
				this.list2.forEach(item=>{
					item.customerPrice=parseFloat(item.customerPrice)
					item.discountPrice=parseFloat(item.discountPrice)
					item.normalPrice=parseFloat(item.normalPrice)
				})
                console.log(this.list1)
            }

        },
    },
    mounted() {


    },
    methods:{
        goGoodsdetail(item){
            this.$router.push({path:'/ProductDetail',query: {id:item.id}}) //
        },
    },

}
</script>

<style scoped>
.product-row .product-con .list .activeitem{
    min-width: 158px !important;
}
.product-row .product-con .list .noactiveitem{
    min-width: 190px !important;
}
.product-row .product-con .list .item.active{
    min-width: 306px !important;
}
.product-row .product-con .list .def .pic{
    width: 70px;
}
.el-image .img{
    width: 100%;
    height: 100%;
}
</style>
<style lang="scss">
.product-row .product-con .list .def .pic{
    width: 70px;
}
.product-row .pic .el-image .image-slot{
    width: 100%;
    height: 100%;
    //padding: 10px;
}
</style>
